import FocusableIconButton from '@components/FocusableIconButton';
import { useAuthContext } from '@context/Auth';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { ROOT } from '@router/path';
import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { SIGN_OUT_CANCEL, SIGN_OUT_OK } from './focusKey';

import * as styles from './styles';

const SignOut = () => {
  const { signOut } = useAuthContext();

  const { focusKey, setFocus } = useFocusable();

  useEffect(() => {
    setFocus(SIGN_OUT_OK);
  }, [setFocus]);

  const navigate = useNavigate();

  const goMain = useCallback(() => {
    navigate(ROOT);
  }, [navigate]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div css={styles.container}>
        <div css={styles.mainContainer}>
          <div css={styles.text}>굿닥에서 로그아웃 하시겠어요?</div>
          <div css={styles.buttonContainer}>
            <FocusableIconButton
              focusKey={SIGN_OUT_OK}
              onEnterPress={() => {
                // TODO: pop all history
                goMain();
                signOut();
              }}
              iconType="arrow"
              buttonStyle={styles.button}
            >
              로그아웃
            </FocusableIconButton>
            <FocusableIconButton
              focusKey={SIGN_OUT_CANCEL}
              onEnterPress={goMain}
              iconType="cancel"
              buttonStyle={styles.button}
            >
              취소
            </FocusableIconButton>
          </div>
        </div>
      </div>
    </FocusContext.Provider>
  );
};

export default SignOut;
